<template>
  <div class="loading-container">
    <div class="loading-spinner">
      <div class="spinner-circle"></div>
      <svg width="214" height="175" viewBox="0 0 214 175" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path class="path-1" d="M213.03 170.92C204.11 166.25 194.49 162.74 184.36 160.6C176.87 159.02 169.11 158.19 161.15 158.19C154.91 158.19 148.79 158.7 142.83 159.69C135.77 160.85 128.94 162.67 122.39 165.09C120.88 165.65 119.38 166.24 117.9 166.86C109.97 170.19 101.7 172.77 93.16 173.89C89.06 174.43 84.87 174.71 80.62 174.71C74.52 174.71 68.55 174.13 62.78 173.03C58.85 172.3 55.01 171.31 51.27 170.09C50.04 169.7 48.84 169.28 47.63 168.83C45.52 168.06 43.45 167.21 41.41 166.29C40.01 165.53 38.64 164.74 37.29 163.9C35.06 162.55 32.9 161.09 30.79 159.56C25.27 155.55 20.2 150.94 15.68 145.84C9.3 138.68 3.99 130.54 0 121.68C14.64 129.63 31.42 134.13 49.26 134.14C52.98 134.14 56.65 133.94 60.26 133.56C61.62 133.42 62.97 133.26 64.31 133.06C67.12 132.66 69.89 132.13 72.62 131.51L72.97 131.43L73.13 131.39C74.06 131.18 74.99 130.94 75.91 130.69L75.98 130.67L89.99 127.14L112.79 121.39C112.79 121.39 112.81 121.39 112.82 121.37H112.85L112.92 121.35L114.8 120.88C122.29 119.05 130.12 118.08 138.16 118.08C141.76 118.08 145.33 118.28 148.83 118.66C154.51 119.65 160.01 121.14 165.29 123.1C166.36 123.49 167.42 123.9 168.47 124.33C169.55 124.88 170.61 125.46 171.66 126.06C171.79 126.13 171.92 126.19 172.04 126.27C189.95 136.46 204.35 152.09 213 170.93L213.03 170.92Z" fill="#FFBE00"/>
        <path class="path-2" d="M190.79 132.281C184.24 126.791 176.89 122.131 168.87 118.521C162.95 115.851 156.65 113.761 150.05 112.311C144.88 111.181 139.71 110.491 134.58 110.231C128.51 109.911 122.51 110.181 116.64 111.001C115.05 111.221 113.46 111.491 111.88 111.791C109.32 112.281 106.76 112.811 104.17 113.021C96.35 113.661 88.31 113.171 80.24 111.411C75.18 110.301 70.33 108.741 65.74 106.781C62.61 105.461 59.6 103.941 56.72 102.261C55.77 101.721 54.85 101.151 53.93 100.561C52.32 99.5408 50.76 98.4608 49.23 97.3208C48.21 96.4408 47.21 95.5308 46.24 94.5908C44.63 93.0708 43.1 91.4708 41.64 89.8108C37.79 85.4808 34.42 80.7408 31.59 75.6908C27.59 68.5908 24.67 60.8808 22.96 52.8008C33.67 62.0508 46.77 68.8308 61.57 72.0608C64.66 72.7308 67.73 73.2408 70.8 73.5808C71.95 73.7108 73.1 73.8208 74.25 73.9008C76.65 74.0708 79.05 74.1408 81.43 74.1208H81.73H81.87C82.68 74.1208 83.49 74.0808 84.3 74.0408H84.36L96.62 73.6508L116.58 73.0108C116.58 73.0108 116.6 73.0108 116.61 73.0108H116.64H116.7L118.34 72.9608C124.88 72.8008 131.56 73.4208 138.23 74.8808C141.22 75.5308 144.14 76.3408 146.98 77.2908C151.51 79.1408 155.81 81.3808 159.83 83.9608C160.65 84.4708 161.45 85.0108 162.24 85.5608C163.03 86.2108 163.81 86.8808 164.58 87.5708C164.68 87.6508 164.77 87.7308 164.86 87.8108C177.87 99.5108 186.99 115.091 190.75 132.291L190.79 132.281Z" fill="#FFBE00"/>
        <path class="path-3" d="M177.12 93.4C172.53 87.76 167.13 82.68 161.01 78.38C156.49 75.2 151.56 72.43 146.28 70.17C142.14 68.39 137.93 66.99 133.68 65.94C128.66 64.7 123.6 63.96 118.56 63.7C117.19 63.63 115.82 63.6 114.46 63.6C112.24 63.6 110.02 63.63 107.81 63.39C101.17 62.67 94.5204 60.97 88.0704 58.2C84.0204 56.46 80.2204 54.38 76.6904 52C74.2904 50.39 72.0204 48.64 69.8804 46.77C69.1804 46.16 68.4904 45.54 67.8204 44.9C66.6404 43.79 65.5104 42.63 64.4104 41.44C63.7004 40.54 63.0104 39.62 62.3504 38.68C61.2504 37.15 60.2304 35.56 59.2704 33.94C56.7504 29.7 54.6904 25.2 53.1404 20.52C50.9404 13.94 49.7304 7.02 49.6104 0C57.0704 9.45 66.9404 17.23 78.7904 22.31C81.2604 23.37 83.7504 24.28 86.2604 25.06C87.2004 25.35 88.1404 25.63 89.0904 25.88C91.0704 26.41 93.0604 26.85 95.0504 27.21L95.3004 27.25L95.4204 27.27C96.1004 27.39 96.7804 27.5 97.4704 27.6H97.5204L107.83 29.26L124.61 31.93C124.61 31.93 124.62 31.93 124.64 31.93H124.66L124.71 31.94L126.09 32.16C131.59 33.07 137.06 34.67 142.41 36.96C144.8 37.99 147.11 39.13 149.33 40.38C152.82 42.65 156.05 45.22 159 48.02C159.6 48.58 160.19 49.16 160.76 49.74C161.32 50.41 161.86 51.1 162.39 51.8C162.46 51.88 162.52 51.96 162.58 52.04C171.57 63.91 176.69 78.4 177.07 93.38L177.12 93.4Z" fill="#FFBE00"/>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingSpinner'
}
</script>

<style scoped>
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
}

.loading-spinner {
  position: relative;
  width: 100px;
  height: 100px;
}

.loading-spinner svg {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60%;
  height: 60%;
}

.spinner-circle {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 4px solid rgba(255, 190, 0, 0.2);
  border-top: 4px solid #FFBE00;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.path-1 {
  animation: fade 2s ease-in-out infinite;
  animation-delay: 0s;
}

.path-2 {
  animation: fade 2s ease-in-out infinite;
  animation-delay: 0.4s;
}

.path-3 {
  animation: fade 2s ease-in-out infinite;
  animation-delay: 0.8s;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes fade {
  0%, 100% {
    opacity: 0.2;
  }
  50% {
    opacity: 1;
  }
}
</style> 